import { defineStore } from 'pinia'
import { newCall } from '@/util/http'
import { debounce } from '@safety/shared-utils'

export const useInboxStore = defineStore('inbox', {
  state: () => ({
    unreadCount: 0,
    _debouncedFetch: null
  }),
  actions: {
    updateUnreadCount(count) {
      this.unreadCount = count
    },
    adjustUnreadCount(delta) {
      this.unreadCount = Math.max(0, this.unreadCount + delta)
    },
    async _fetchUnreadCount() {
      const { code, data, message } = await newCall({ url: 'inbox/unreadCount' })
      if (code === 0) {
        const count = data?.unreadCount || 0
        this.updateUnreadCount(count)
        return count
      }
      throw new Error(message)
    },
    _getDebouncedFetch() {
      if (!this._debouncedFetch) {
        this._debouncedFetch = debounce(() => this._fetchUnreadCount(), 300, true)
      }
      return this._debouncedFetch
    },
    async fetchUnreadCount(options = {}) {
      const { debounce: useDebounce = false } = options

      try {
        if (useDebounce) {
          return await this._getDebouncedFetch()()
        }
        return await this._fetchUnreadCount()
      } catch (error) {
        console.error('[InboxStore] 获取未读数量失败', error)
        return this.unreadCount || 0
      }
    }
  }
})
